import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DEFAULT_ERROR_TYPE_LABELS, ErrorTypeLabels } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-error-field',
  imports: [CommonModule],
  templateUrl: './error-field.component.html',
  styleUrl: './error-field.component.scss'
})
export class ErrorFieldComponent {
  control = input.required<AbstractControl>();
  errorMessages = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);

  getErrors(): string[] {
    return Object.keys(this.control().errors!);
  }

  getErrorMessage(errorKey: string): string {
    const control = this.control();
    const messages = this.errorMessages();
    let message = errorKey in messages ? messages[errorKey]! : errorKey;

    if (errorKey === 'minlength' && control.errors?.[errorKey]?.['requiredLength']) {
      const minLength = control.errors[errorKey]['requiredLength'];
      message = (messages['minlength'] || 'Minimum {min} characters required').replace('{min}', minLength);
    } else if (errorKey === 'maxlength' && control.errors?.[errorKey]?.['requiredLength']) {
      const maxLength = control.errors[errorKey]['requiredLength'];
      message = (messages['maxlength'] || 'Maximum {max} characters allowed').replace('{max}', maxLength);
    }

    return message;
  }
}
